import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
const modules = [{
  icon: '🌟',
  title: 'INTRODUCCIÓN',
  desc: 'Una nueva forma de entender tu cuerpo después de los 40'
}, {
  icon: '🔥',
  title: 'MÓDULO 1',
  desc: 'Tu cuerpo cambia... y no es tu culpa'
}, {
  icon: '💪',
  title: 'MÓDULO 2',
  desc: 'El metabolismo femenino explicado de forma simple'
}, {
  icon: '🍽️',
  title: 'MÓDULO 3',
  desc: 'Las razones reales por las que no bajas de peso'
}, {
  icon: '❌',
  title: 'MÓDULO 4',
  desc: 'Errores comunes que sabotean tu peso después de los 40'
}, {
  icon: '✅',
  title: 'MÓDULO 5',
  desc: 'Enfócate en la calidad y combinación de alimentos'
}];
export function ContentPreview() {
  const checkoutUrl = 'https://www.yennilemon.com/cart/44211058212999:1';
  return <section className="bg-white py-16 md:py-24 px-4 overflow-hidden" data-id="element-26">
      <div className="max-w-5xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-28">
          <span className="text-sage font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-29">
            Contenido Real
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-olive mb-4" data-id="element-30">
            Mira lo que encontrarás dentro
          </h2>
          <p className="text-lg md:text-xl text-warm-gray max-w-2xl mx-auto" data-id="element-31">
            Páginas reales de la guía para que veas la calidad y el cariño con
            que fue creada.
          </p>
        </motion.div>

        {/* Image Cards Preview */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-20" data-id="element-32">
          {[{
          src: 'https://cdn.magicpatterns.com/uploads/7U2JNiido3dF8SQWkSwKSu/paginasebook_(1).png',
          alt: 'Mapa del camino - Índice de la guía'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/qxHrW3ZFETxrwh4HA2dywV/paginasebook_(2).png',
          alt: 'Módulo 5 - Calidad y combinación de alimentos'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/2b7VdbimWEaATVy6MMcHhM/paginasebook_(3).png',
          alt: 'Cómo usar el planificador'
        }].map((img, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 50,
          rotate: 0
        }} whileInView={{
          opacity: 1,
          y: 0,
          rotate: idx === 0 ? -6 : idx === 2 ? 6 : 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2,
          duration: 0.6
        }} className={`relative w-64 md:w-72 rounded-xl shadow-2xl overflow-hidden border-4 border-white ${idx === 1 ? 'z-10 md:-translate-y-8' : 'z-0'}`} data-id="element-33">
              <img src={img.src} alt={img.alt} className="w-full h-auto object-cover" data-id="element-34" />
            </motion.div>)}
        </div>

        {/* Table of Contents */}
        <div className="max-w-3xl mx-auto bg-cream p-8 md:p-12 rounded-3xl shadow-soft" data-id="element-35">
          <h3 className="text-2xl font-heading font-bold text-olive mb-8 text-center" data-id="element-36">
            Índice del Programa
          </h3>
          <div className="space-y-6" data-id="element-37">
            {modules.map((mod, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-4 border-b border-sage/20 pb-6 last:border-0 last:pb-0" data-id="element-38">
                <div className="text-2xl mt-1" data-id="element-39">{mod.icon}</div>
                <div data-id="element-40">
                  <h4 className="font-bold text-olive text-lg" data-id="element-41">{mod.title}</h4>
                  <p className="text-warm-gray mt-1" data-id="element-42">{mod.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-43">
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-block bg-sage hover:bg-sage-dark text-white font-bold py-4 px-10 rounded-full transition-all transform hover:scale-[1.02] shadow-md text-lg" data-id="element-44">
            Descargar ahora por $6.36 USD
          </a>
        </motion.div>
      </div>
    </section>;
}